import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["pagination", "nextpage"]
  static values = { element: String, url: String, page: String}

  initialize() {
    let options = {
      rootMargin: '200px',
    }

    this.intersectionObserver = new IntersectionObserver(entries => this.processIntersectionEntries(entries), options)
  }

  connect() {
    this.intersectionObserver.observe(this.paginationTarget)
  }

  disconnect() {
    this.intersectionObserver.unobserve(this.paginationTarget)
  }

  processIntersectionEntries(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.loadMore()
      }
    })
  }

  loadMore() {
    let page = parseInt(this.nextpageTarget.value)
    let nextPage = page + 1
    let separator = this.urlValue.includes('?') ? '&' : '?'
    let url = this.urlValue + `${separator}page=${nextPage}`
    let element = document.getElementById(this.elementValue)
    this.nextpageTarget.value = nextPage
    fetch(url, { headers: { accept: "application/json" } })
      .then(response => response.json())
      .then((data) => {
        element.insertAdjacentHTML('beforeend', data.entries)
      })
  }
}
